// styles.tsx
import styled from 'styled-components';
import { newNormalizeHeight, newNormalizeWidth, normalizeHeightToVH, normalizeWidthToVW } from '../../utils/normalize';

export const BackgroundImg = styled.img`
  position: absolute;
  top: 0;
  right: 0;
  z-index: 0;
  overflow: hidden;
  min-height: ${newNormalizeHeight(900)};
  min-width: ${newNormalizeWidth(1440)};
  height: 100%;
`;

export const LogoWrapper = styled.div`
  position: absolute;
  top: ${normalizeHeightToVH(25)};
  left: ${normalizeWidthToVW(36)};
  min-width: 88px;
  min-height: 35px;
  max-width: 88px;
  max-height: 35px;
  z-index: 1;
`;

export const CadastroContainer = styled.div`
  position: absolute;
  top: ${normalizeHeightToVH(202)};
  left: ${normalizeWidthToVW(191)};
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: ${newNormalizeHeight(28)}px;

  width: 406px;
`;

export const CadastroTexts = styled.p`
  font-style: normal;
  font-weight: 700;
  font-size: 32px;
  line-height: 125%;
  color: #4D4D4D;
  text-align: center;
`;

export const InputContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const BottomContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Text = styled.p`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 125%;
  color: #666666;
`;

export const Href = styled.a`
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 125%;
  color: #6E30E9;
  cursor: pointer;
`;

export const SocialContainer = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-direction: column;
`;

export const SocialButton = styled.button`
  width: 100%;
  height: 42px;
  border-radius: 8px;
  background-color: #F5F5F5;
  border: 1px solid #D0D5DD;
  text-align: center;
  gap: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  outline: none;
`;

export const SocialButtonText = styled.p`
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 125%;
  color: #666666;
`;


export const Text2 = styled.p`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 125%;
  color: #666666;
  text-align: center;
`;